import { render, staticRenderFns } from "./NonMarketBase.vue?vue&type=template&id=8df45adc&scoped=true&"
import script from "./NonMarketBase.vue?vue&type=script&lang=js&"
export * from "./NonMarketBase.vue?vue&type=script&lang=js&"
import style0 from "./NonMarketBase.vue?vue&type=style&index=0&id=8df45adc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df45adc",
  null
  
)

export default component.exports